import { getLoggedInCustomerInformation } from '@booking-portal/api/services/customer-portal-service';
import { queryClient } from '@booking-portal/plugins/vue-query-plugin';
import type { IAuthCustomer } from '@booking-portal/types';
import type { IResponse } from '@booking-portal/types/api';
import { useQuery } from '@tanstack/vue-query';
import type { Maybe } from 'shared/types';
import type { MaybeRefOrGetter } from 'vue';

import { queryOptions } from './use-customer-portal-queries';

export function useLoggedInCustomer(enabled: MaybeRefOrGetter<boolean>) {
  return useQuery({
    queryKey: ['customer'],
    queryFn: () => getLoggedInCustomerInformation(),
    enabled,
    ...queryOptions,
  });
}

export function prefillLoggedInCustomerQuery(
  loggedInCustomer: Maybe<IResponse<IAuthCustomer>>
) {
  queryClient.setQueryData(['customer'], loggedInCustomer);
}

export function invalidateLoggedInCustomerQuery() {
  return queryClient.invalidateQueries({ queryKey: ['customer'] });
}
